import styled from "styled-components";
import PublicHeader from "./PublicHeader";
import { PublicTemplateProps } from "../../constants/types";

const PublicTemplate = (props: PublicTemplateProps) => {
  return (
    <Container>
      <PublicHeader />
      <Body
        style={{
          flexWrap: props.wrap ? "wrap" : "nowrap",
          justifyContent: props.justify ? props.justify : "center",
          alignContent: props.align ? props.align : "center",
        }}
      >
        {props.children}
      </Body>
    </Container>
  );
};

export default PublicTemplate;

const Container = styled.div`
  width: 100%;
  height: 100%;
`;

const Body = styled.div`
  width: 100%;
  height: 92%;

  display: flex;
  justify-content: center;
  box-sizing: border-box;
  padding: 1%;
`;
